import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FilesService } from 'src/app/_services/files/files.service';

@Component({
  selector: 'app-preview-documents-modal',
  templateUrl: './preview-documents-modal.component.html',
  styleUrls: ['./preview-documents-modal.component.scss']
})
export class PreviewDocumentsModalComponent {

  @Input() filesUrls!: string[];
  blobStorageBaseUrl = 'https://limitlesscarestorage.blob.core.windows.net';
  isDownloadingAll: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private filesService: FilesService
  ) {}

  closeModal(): void {
    this.activeModal.close();
  }

  downloadDocument(fileUrl: string, event: any): void {
    // Prevent the default action of href
    event.preventDefault();
    event.stopPropagation();

    const fullUrl = this.blobStorageBaseUrl + "/" + fileUrl;
    this.filesService.downloadFile(fullUrl);
  }

  downloadAllFiles(): void {
    if (!this.filesUrls || this.filesUrls.length === 0) {
      return;
    }

    this.isDownloadingAll = true;

    // Create full URLs for all files
    const fullUrls = this.filesUrls.map(fileUrl => 
      this.blobStorageBaseUrl + "/" + fileUrl
    );

    // Use existing service method to download multiple files
    this.filesService.downloadMultipleFiles(fullUrls);
    
    // Reset loading state after a short delay
    setTimeout(() => {
      this.isDownloadingAll = false;
    }, 1000);
  }
}